import styled from 'styled-components'
import { CLIENT_STYLINGS } from '../../../utils/constants'
import { getBorderRadius } from '../../../utils/styleUtils'
import Input from './Input'

export const StyledInput = styled(Input)`
  height: 36px;
  width: 100%;
  min-width: 0;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 20px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  color: ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  box-sizing: border-box;
  transition: border 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
    opacity: 0.8;
  }

  &:focus {
    outline: none;
    border-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    box-shadow: 0 0 0 3px
      ${props =>
        `${CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY}40`};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &[aria-invalid='true'] {
    border-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.DESTRUCTIVE};
    box-shadow: 0 0 0 3px
      ${props =>
        `${CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.DESTRUCTIVE}40`};
  }
` 